module.exports = __webpack_public_path__ + "img/IMG_1024_L_Black.04bc17b0.jpg";